// accordion.js
document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('.accordion-button');

  accordions.forEach(function (accordion) {
    accordion.addEventListener('click', function () {
      const index = this.getAttribute('data-index');
      const targetCollapse = document.getElementById('collapse-' + index);

      // Toggle the aria-expanded attribute
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isExpanded);

      // Toggle the aria-hidden attribute
      const isHidden = targetCollapse.getAttribute('aria-hidden') === 'true';
      targetCollapse.setAttribute('aria-hidden', !isHidden);

      // Toggle the class to show/hide the content
      targetCollapse.classList.toggle('is-open');

      // Close other accordions
      closeOtherAccordions(index);
    });
  });

  function closeOtherAccordions(currentIndex) {
    const accordions = document.querySelectorAll('.accordion-button');
    accordions.forEach(function (accordion, index) {
      if (index !== currentIndex) {
        accordion.setAttribute('aria-expanded', 'false');
        const targetCollapse = document.getElementById('collapse-' + index);
        targetCollapse.setAttribute('aria-hidden', 'true');
        targetCollapse.classList.remove('is-open');
      }
    });
  }
});
